// Lista de circuitos de carreras para selección en el formulario de alta de carrera

export const CIRCUITOS = [
  "Alemania Berlin Street circuit",
  "Alemania Berlin Tempelhof circuit",
  "Alemania Estering",
  "Alemania EuroSpeedway Lausitz",
  "Alemania Hockenheimring",
  "Alemania Matschenberg Offroad Arena",
  "Alemania Motorsport Arena Oschersleben",
  "Alemania Norisring",
  "Alemania Nürburgring",
  "Alemania Sachsenring",
  "Alemania Seelow Autocross circuit",
  "Arabia Saudita Reem International circuit",
  "Arabia Saudita Riyadh Street circuit",
  "Argentina Autodromo Ciudad de Rosario",
  "Argentina Autodromo General San Martin",
  "Argentina Autodromo Internacional del Neuquen",
  "Argentina Autodromo Jose Carlos Bassi",
  "Argentina Autodromo Juan y Oscar Galvez",
  "Argentina Autodromo Termas de Rio Hondo",
  "Argentina Circuito San Juan Villicum",
  "Argentina Potrero de los Funes circuit",
  "Argentina Puerto Madero Street circuit",
  "Australia Adelaide Street circuit",
  "Australia Barbagallo Raceway",
  "Australia Baskerville Raceway",
  "Australia Gold Coast Street circuit",
  "Australia Hidden Valley Raceway",
  "Australia Lakeside International Raceway",
  "Australia Mallala Motor Sport Park",
  "Australia Melbourne Grand Prix circuit",
  "Australia Morgan Park Raceway",
  "Australia Mount Panorama circuit",
  "Australia Newcastle Street circuit",
  "Australia Phillip Island Grand Prix circuit",
  "Australia Queensland Raceway",
  "Australia Sandown Raceway",
  "Australia Sydney Motorsport Park",
  "Australia Sydney Olympic Park circuit",
  "Australia Symmons Plains Raceway",
  "Australia The Bend Motorsport Park",
  "Australia Townsville Street circuit",
  "Australia Wakefield Park Raceway",
  "Australia Winton Motor Raceway",
  "Austria Red Bull Ring",
  "Austria Salzburgring",
  "Azerbaiyán Baku City circuit",
  "Barbados Bushy Park circuit",
  "Baréin Bahrain International circuit",
  "Bélgica circuit de Spa Francorchamps",
  "Bélgica circuit Jules Tacheny Mettet",
  "Bélgica circuit Zolder",
  "Brasil Autodromo Internacional de Cascavel",
  "Brasil Autodromo Internacional de Goiânia",
  "Brasil Autodromo Internacional de Londrina",
  "Brasil Autodromo Internacional de Santa Cruz do Sul",
  "Brasil Autodromo Internacional de Tarumã",
  "Brasil Autodromo Internacional Orlando Moura",
  "Brasil Autodromo Jose Carlos Pace",
  "Brasil Autodromo Velo Città",
  "Brasil Velopark",
  "Canadá Canadian Tire Motorsport Park",
  "Canadá circuit Gilles Villeneuve",
  "Canadá circuit Trois Rivières",
  "Canadá Montreal Street circuit",
  "Canadá Toronto Street circuit",
  "Chile Autodromo Interlomas",
  "Chile Autodromo Internacional de Codegua",
  "Chile Parque O'Higgins circuit",
  "Chile Santiago Street circuit",
  "China Auto World Tianjin",
  "China Beijing Olympic Green circuit",
  "China Chengdu International circuit",
  "China Goldenport Park circuit",
  "China Haitang Bay circuit",
  "China Jiangsu Wantrack International circuit",
  "China Ningbo International circuit",
  "China Ordos International circuit",
  "China Shanghai International circuit",
  "China Shanghai Tianma circuit",
  "China Shougang Motorsport Valley",
  "China Wuhan Street circuit",
  "China Zhejiang International circuit",
  "China Zhuhai International circuit",
  "Colombia Autodromo Tocancipa",
  "Corea del Sur Everland Speedway",
  "Corea del Sur Inje Speedium",
  "Corea del Sur Korea International circuit",
  "Corea del Sur Songdo Street circuit",
  "Costa Rica Autodromo La Guacima",
  "Croacia Automotodrom Grobnik",
  "Dinamarca Jyllands Ringen",
  "Dinamarca Padborg Park",
  "Dinamarca Ring Djursland",
  "Ecuador Autodromo Internacional Jose Tobar",
  "Emiratos Árabes Unidos Dubai Autodrome",
  "Emiratos Árabes Unidos Yas Marina circuit",
  "Eslovaquia Automotodrom Slovakiaring",
  "España circuit de Barcelona Catalunya",
  "España circuit Ricardo Tormo",
  "España Circuito de Almeria",
  "España Circuito de Jerez",
  "España Circuito de Navarra",
  "España Circuito del Jarama",
  "España Ciudad del Motor de Aragon",
  "Estados Unidos Atlanta Motorsports Park",
  "Estados Unidos Barber Motorsports Park",
  "Estados Unidos Biscayne Bay Street circuit",
  "Estados Unidos Brooklyn Street circuit",
  "Estados Unidos circuit of the Americas",
  "Estados Unidos Detroit Belle Isle Street circuit",
  "Estados Unidos Indianapolis Motor Speedway",
  "Estados Unidos Lime Rock Park",
  "Estados Unidos Long Beach Street circuit",
  "Estados Unidos Mid Ohio Sports Car Course",
  "Estados Unidos NOLA Motorsports Park",
  "Estados Unidos Portland International Raceway",
  "Estados Unidos Road America",
  "Estados Unidos Road Atlanta",
  "Estados Unidos Sebring International Raceway",
  "Estados Unidos Sonoma Raceway",
  "Estados Unidos St. Petersburg Street circuit",
  "Estados Unidos Virginia International Raceway",
  "Estados Unidos Watkins Glen International",
  "Estados Unidos WeatherTech Raceway Laguna Seca",
  "Estonia Auto24ring",
  "Filipinas Batangas Racing circuit",
  "Filipinas Clark International Speedway",
  "Finlandia Ahvenisto Race circuit",
  "Finlandia Kymi Ring",
  "Francia circuit de la Sarthe",
  "Francia circuit de Ledenon",
  "Francia circuit de Loheac",
  "Francia circuit de Nevers Magny Cours",
  "Francia circuit de Pau Ville",
  "Francia circuit des ducs Essay",
  "Francia circuit des Invalides",
  "Francia circuit du Val de Vienne",
  "Francia circuit Paul Armagnac",
  "Francia circuit Paul Ricard",
  "Francia circuit Saint Georges de Montaigu",
  "Francia circuit Saint Igny de Vers",
  "Francia Dijon Prenois",
  "Georgia Rustavi International Motorpark",
  "Grecia Serres Racing circuit",
  "Guatemala Autodromo Pedro Cofiño",
  "Hong Kong Central Harbourfront circuit",
  "Hungría Hungaroring",
  "Hungría Nyirad Motorsport Centrum",
  "India Buddh International circuit",
  "India Madras Motor Race Track",
  "Indonesia Sentul International circuit",
  "Irlanda Mondello Park",
  "Italia Adria International Raceway",
  "Italia Autodromo dell'Umbria",
  "Italia Autodromo di Enna Pergusa",
  "Italia Autodromo Enzo e Dino Ferrari",
  "Italia Autodromo Nazionale Monza",
  "Italia Autodromo Riccardo Paletti",
  "Italia Circuito Cittadino dell'EUR",
  "Italia Fiorano circuit",
  "Italia Franciacorta International circuit",
  "Italia Maggiora Offroad Arena",
  "Italia Misano World circuit Marco Simoncelli",
  "Italia Mugello circuit",
  "Italia Vallelunga circuit",
  "Japón Autopolis",
  "Japón Fuji Speedway",
  "Japón Okayama International circuit",
  "Japón Sportsland SUGO",
  "Japón Suzuka circuit",
  "Japón Tokachi International Speedway",
  "Japón Tsukuba circuit",
  "Japón Twin Ring Motegi",
  "Kuwait Kuwait Motor Town",
  "Letonia Biķernieku Kompleksā Sporta Bāze",
  "Lituania Palanga circuit",
  "Lituania Vilkyciai circuit",
  "Luxemburgo circuit Goodyear",
  "Macao Guia circuit",
  "Malasia Kuala Lumpur Street circuit",
  "Malasia Putrajaya Street circuit",
  "Malasia Sepang International circuit",
  "Marruecos circuit International Automobile Moulay El Hassan",
  "México Autodromo Hermanos Rodriguez",
  "México Autodromo Miguel E. Abed",
  "México Autodromo Monterrey",
  "México Autodromo Yucatan",
  "Mónaco circuit de Monaco",
  "Namibia Tony Rust Raceway",
  "Noruega Arctic Circle Raceway",
  "Noruega Rudskogen Motorsenter",
  "Noruega Vålerbanen",
  "Nueva Zelanda Bruce McLaren Motorsport Park",
  "Nueva Zelanda circuit Chris Amon",
  "Nueva Zelanda Hamilton Street circuit",
  "Nueva Zelanda Hampton Downs Motorsport Park",
  "Nueva Zelanda Highlands Motorsport Park",
  "Nueva Zelanda Pukekohe Park Raceway",
  "Nueva Zelanda Ruapuna Park",
  "Nueva Zelanda Teretonga Park",
  "Nueva Zelanda Timaru International Motor Raceway",
  "Países Bajos circuit Zandvoort",
  "Países Bajos Eurocircuit Valkenswaard",
  "Países Bajos TT circuit Assen",
  "Perú Autodromo Tacna",
  "Polonia Tor Poznań",
  "Portugal Algarve International circuit",
  "Portugal Autodromo Fernanda Pires da Silva",
  "Portugal Pista Automovel de Montalegre",
  "Portugal Vila Real Street circuit",
  "Puerto Rico Ponce International circuit",
  "Qatar Losail International circuit",
  "Reino Unido Anglesey circuit",
  "Reino Unido Battersea Park Street circuit",
  "Reino Unido Bishopscourt Racing circuit",
  "Reino Unido Brands Hatch",
  "Reino Unido Castle Combe circuit",
  "Reino Unido Croft circuit",
  "Reino Unido Donington Park",
  "Reino Unido Knockhill Racing circuit",
  "Reino Unido Oulton Park",
  "Reino Unido Pembrey circuit",
  "Reino Unido Silverstone circuit",
  "Reino Unido Snetterton circuit",
  "Reino Unido Thruxton circuit",
  "República Checa Auto Klub Přerov",
  "República Checa Autocross Nova Paka",
  "República Checa Autodrom Most",
  "República Checa Brno circuit",
  "República Dominicana Autodromo Internacional de Las Americas",
  "Rumanía Bucharest Ring",
  "Rumanía Transylvania Motor Ring",
  "Rusia Fort Grozny Autodrom",
  "Rusia Kazan Ring",
  "Rusia Moscow Raceway",
  "Rusia Moscow Street circuit",
  "Rusia NRing circuit",
  "Rusia Smolensk Ring",
  "Rusia Sochi Autodrom",
  "Senegal circuit de Dakar Baobabs",
  "Singapur Marina Bay Street circuit",
  "Sudáfrica Killarney Motor Racing Complex",
  "Sudáfrica Kyalami circuit",
  "Sudáfrica Phakisa Raceway",
  "Sudáfrica Prince George circuit",
  "Suecia Falkenbergs Motorbana",
  "Suecia Gothenburg City Race Arena",
  "Suecia Höljesbanan",
  "Suecia Karlskoga Motorstadion",
  "Suecia Mantorp Park",
  "Suecia Ring Knutstorp",
  "Suecia Scandinavian Raceway",
  "Suecia Skellefteå Drive Center",
  "Suecia Skövde Airport circuit",
  "Suecia Solvalla Stockholm",
  "Suiza Bern Street circuit",
  "Suiza Zürich Street circuit",
  "Tailandia Bangsaen Street circuit",
  "Tailandia Bira circuit",
  "Tailandia Buriram International circuit",
  "Taiwán Lihpao International circuit",
  "Taiwán Penbay International circuit",
  "Turquía Istanbul Park",
  "Uruguay Autodromo Victor Borrat Fabini",
  "Uruguay Punta del Este Street circuit",
  "Venezuela San Carlos circuit",
  "Zimbabue Donnybrook Raceway"
];
